import React, { useState, useEffect } from 'react';
import { useNavigate, Outlet, useLocation } from 'react-router-dom';
// 👇 Importaciones locales correctas
import SupplierSidebar from '@/features/proveedores/components/SupplierSidebar';
import { SupplierHeader } from '@/features/proveedores/components/SupplierHeader';
import { SupplierNotificationsProvider } from '@/context/SupplierNotificationsContext';

interface SupplierLayoutProps {
  children?: React.ReactNode;
  activeRoute?: string;
}

const SupplierLayout = ({ children, activeRoute = 'dashboard' }: SupplierLayoutProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [currentRoute, setCurrentRoute] = useState(activeRoute);

  // Sincronizar ruta si cambia externamente (navegación por URL)
  useEffect(() => {
    const pathPart = location.pathname.split('/').pop();
    if (pathPart) setCurrentRoute(pathPart);
  }, [location]);

  const handleNavigate = (route: string) => {
    navigate(route);
    setCurrentRoute(route.split('/').pop() || 'dashboard');
  };

  return (
    // 👇 1. Envolvemos con el Provider de notificaciones
    <SupplierNotificationsProvider>
      <div className="flex h-screen bg-gray-50">

        <SupplierSidebar activeRoute={currentRoute} onNavigate={handleNavigate} />

        {/* 👇 2. Tu estructura de diseño original intacta */}
        <div className="flex-1 ml-20 flex flex-col h-screen overflow-hidden transition-all duration-300">

          {/* El Header tiene z-10 y el Sidebar z-20, así que el Sidebar queda encima */}
          <SupplierHeader />

          {/* Sin z-index propio: con `z-0` este main creaba un stacking context y
              atrapaba a los modales de las páginas por debajo del header/sidebar. */}
          <main className="flex-1 overflow-auto bg-gray-50 px-6 pb-6 pt-0 relative">
            {/* 👇 3. Renderizamos Outlet + Children */}
            <Outlet />
            {children}
          </main>
        </div>
      </div>
    </SupplierNotificationsProvider>
  );
};

export default SupplierLayout;